import React, { useState } from "react";
import { FCard, FContainer, FInputText, FButton } from "ferrum-design-system";
import { RiFileCopy2Fill, RiSearch2Line, RiTimeLine } from "react-icons/ri";
import TimerLoaderIcon from "../../../../assets/ms-new-images/icons/time-loader-icon.svg";
import CompletedTickGreenIcon from "../../../../assets/ms-new-images/icons/tick-screen-icon.svg";
import CompletedTickIcon from "../../../../assets/ms-new-images/icons/tick-icon.svg";
import iconWarning from "../../../../assets/img/icon-warning.png";
import TimerIcon from "../../../../assets/ms-new-images/icons/timer-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducer";
import Loader from "../../../../assets/gif/animation-loading.gif";
import Dropdown from "react-dropdown";
import toast from "react-hot-toast";
import * as SwapActions from "../../../../redux/slices/swap";
import "react-dropdown/style.css";
// import { Link } from "react-router-dom";

const AbandonedTransactionPage = () => {
  const dispatch = useDispatch();
  const [network, setNetwork] = useState<any>(undefined);
  const [transactionHash, setTransactionHash] = useState<string>("");
  const { isRegeneratingSwap, regeneratingSwapSystemStatus, networksPayload } =
    useSelector((state: RootState) => ({ ...state.networks, ...state.swap }));

  const options = networksPayload.map((network: any) => {
    return {
      value: network,
      label: (
        <span className="d-flex ai ai-center">
          <img className="f-mr--8" src={network?.logo} width={15} height={15} />{" "}
          {network?.name} (chain ID: {network?.chainId})
        </span>
      ),
    };
  });

  const handleSearchTransaction = () => {
    if (transactionHash && network?.chainId) {
      dispatch(SwapActions.regenerateSwap(transactionHash, network?.chainId));
    }
    setTimeout(() => {
      setTransactionHash("");
      setNetwork(undefined);
      dispatch(SwapActions.resetRegenerateSwap());
    }, 50000);
  };

  // console.log(isRegeneratingSwap, regeneratingSwapStatus);
  // console.log("!transactionHash && !network", !transactionHash || !network);
  return (
    <FContainer width={991}>
      <div className="abandoned-transaction-card">
        <h3 className="abandoned-transaction-card-title">
          Manage Swap Transaction
        </h3>
        <div className="f-mt-2">
          <p>Enter Transaction Hash</p>
          <FInputText
            className={"f-mt--5"}
            type={"text"}
            placeholder={"Transaction Hash"}
            value={transactionHash}
            onChange={(e: any) => setTransactionHash(e.target.value)}
            postfix={
              <RiFileCopy2Fill
                size={15}
                color="white"
                enableBackground={"transparent"}
                onClick={() => {
                  navigator.clipboard.writeText(transactionHash);
                  toast.success("Copied");
                }}
              />
            }
          />
        </div>

        <div className="f-mt-2">
          <p>Enter Transaction Network</p>
          <Dropdown
            className="f-mt--5 dropdown"
            options={options}
            onChange={(e: any) => setNetwork(e?.value)}
            placeholder="Select Network"
          />
        </div>
        <div className="text-center f-mt--5">
          <FButton
            className={`f-mb-2 ${transactionHash && network ? "" : "disable"}`}
            prefix={<RiSearch2Line />}
            postfix={
              isRegeneratingSwap ? (
                <img src={Loader} height={12} width={12} />
              ) : null
            }
            title={`SEARCH TRANSACTION`}
            disabled={(!transactionHash && !network) || isRegeneratingSwap}
            onClick={() => handleSearchTransaction()}
          />
        </div>
      </div>

      <>
        {regeneratingSwapSystemStatus && transactionHash ? (
          <div className="abandoned-transaction-detail">
            <div className="transaction-detail f-mt-3">
              {regeneratingSwapSystemStatus === "swapWithdrawCompleted" ? (
                <div className="d-flex ai ai-center chain-status">
                  <img
                    src={CompletedTickGreenIcon}
                    color="green"
                    height={20}
                    width={20}
                    className="f-mr-1"
                  />
                  <span>Transaction Withdrawal Successful.</span>
                </div>
              ) : regeneratingSwapSystemStatus === "swapWithdrawPending" ||
                regeneratingSwapSystemStatus === "swapPending" ? (
                <>
                  <div className="d-flex ai ai-center chain-status">
                    <img
                      src={TimerIcon}
                      height={20}
                      width={20}
                      className="f-mr-1"
                    />
                    <span>Transaction Is Currently Being Processed.</span>
                  </div>
                  <p className="f-mt-1 f-ml-3 custom-font-size-12">
                    If transaction does not proceed in next 5 minutes, please
                    <a
                      href="https://discord.com/invite/HEfKq57asd"
                      target="_blank"
                    >
                      {" "}
                      Contact Support
                    </a>
                  </p>
                </>
              ) : regeneratingSwapSystemStatus === "swapFailed" ||
                regeneratingSwapSystemStatus === "swapWithdrawFailed" ? (
                <>
                  <div className="d-flex ai ai-center chain-status">
                    <img
                      src={iconWarning}
                      height={20}
                      width={20}
                      className="f-mr-1"
                    />
                    <span>Transaction Is Failed Due to Some Reason.</span>
                  </div>
                  <p className="f-mt-1 f-ml-3 custom-font-size-12">
                    If transaction does not proceed in next 5 minutes, please
                    <a
                      color="#dab46e"
                      href="https://discord.com/invite/HEfKq57asd"
                      target="_blank"
                    >
                      {" "}
                      Contact Support
                    </a>
                  </p>
                </>
              ) : null}
              <div className="f-mt-2 f-ml-1">
                {regeneratingSwapSystemStatus === "swapFailed" ? (
                  <div className="d-flex ai ai-center f-mt-1 system-status">
                    <img
                      src={iconWarning}
                      height={20}
                      width={20}
                      className="f-mr-1"
                    />
                    <span>Swap Failed Due to Some Reason.</span>
                  </div>
                ) : regeneratingSwapSystemStatus === "swapPending" ? (
                  <div className="d-flex ai ai-center f-mt-1 system-status">
                    <img
                      src={TimerIcon}
                      height={20}
                      width={20}
                      className="f-mr-1"
                    />
                    <span>Transaction Swap Processed.</span>
                  </div>
                ) : regeneratingSwapSystemStatus === "swapCompleted" ? (
                  <div className="d-flex ai ai-center f-mt-1 system-status">
                    <img
                      src={CompletedTickIcon}
                      height={20}
                      width={20}
                      className="f-mr-1"
                    />
                    <span>Transaction Swap Processed.</span>
                  </div>
                ) : regeneratingSwapSystemStatus ===
                    "generatorSignatureCreated" ||
                  regeneratingSwapSystemStatus ===
                    "validatorSignatureCreated" ? (
                  <>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={TimerIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Withdrawal item Not Generated.</span>
                    </div>
                    {/* <p>
                    If transaction does not proceed in next 5 minutes, please
                    Contact Support
                  </p> */}
                  </>
                ) : regeneratingSwapSystemStatus === "swapWithdrawGenerated" ||
                  regeneratingSwapSystemStatus === "swapWithdrawPending" ? (
                  <>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Transaction Swap Processed.</span>
                    </div>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Withdrawal Item Generated.</span>
                    </div>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={TimerLoaderIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Withdraw Is In Progress.</span>
                    </div>
                  </>
                ) : regeneratingSwapSystemStatus === "swapWithdrawFailed" ? (
                  <>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Transaction Swap Processed.</span>
                    </div>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Withdrawal Item Generated.</span>
                    </div>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={iconWarning}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Withdraw Failed</span>
                    </div>
                  </>
                ) : regeneratingSwapSystemStatus === "swapWithdrawCompleted" ? (
                  <>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Transaction Swap Processed.</span>
                    </div>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Withdrawal Item Generated.</span>
                    </div>
                    <div className="d-flex ai ai-center f-mt-1 system-status">
                      <img
                        src={CompletedTickIcon}
                        height={20}
                        width={20}
                        className="f-mr-1"
                      />
                      <span>Swap Withdrawn</span>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        ) : null}
      </>
    </FContainer>
  );
};

export default AbandonedTransactionPage;
